import type { HTMLAttributes } from "react";

import { BoxIllustration } from "./box";
import { CloudIllustration } from "./cloud";
import { CreditCardIllustration } from "./credit-card";
import { DocumentsIllustration } from "./documents";

const types = {
	box: BoxIllustration,
	cloud: CloudIllustration,
	"credit-card": CreditCardIllustration,
	documents: DocumentsIllustration,
};

export interface IllustrationProps extends HTMLAttributes<HTMLDivElement> {
	childrenClassName?: string;
	size?: "lg" | "md" | "sm";
	svgClassName?: string;
}

export const Illustration = (
	props: IllustrationProps & { type: keyof typeof types },
) => {
	const { type } = props;

	const Component = types[type];

	return <Component {...props} />;
};
